import { createContext } from 'react';
import { csvParse } from 'd3-dsv';

const localization = `${process.env.PUBLIC_URL}/RavenswoodLocalization.csv`;

const languages = ['english', 'spanish']

export const LanguageContext = createContext(languages[0])

const translationMap = {}

const translationKeyFromRow = d => {
  return `${d.section}-${d.element}`
}

const translationKey = (section, element) => {
  return translationKeyFromRow({section, element})
}

const prepare = (text) => {
  const translations = csvParse(text)
  translations.forEach(row => {
    const key = translationKeyFromRow(row)
    translationMap[key] = row
  })
}

let ready = false;
export function isReady() {
  return ready;
}

window.fetch(localization)
  .then(value => value.text())
  .then(text => {
    prepare(text);
    ready = true;
  });

const log = {}
const logOnce = (...msgs) => {
  let msg = msgs.join(' ')
  if (log[msg]) {
    return
  }
  log[msg] = true
  console.log(...msgs)
}
export function localize(language, section, element) {
  const key = translationKey(section, element)
  if (translationMap[key]) {
    if (translationMap[key][language]) {
      return translationMap[key][language]
    } else {
      logOnce(language, 'language not found', section, element)
    }
  } else {
    logOnce('translation not found', section, element, language)
  }
  return `${language}-${section}-${element}`
}
